export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL as string,
  imageUrl: import.meta.env.VITE_IMAGE_URL as string,
  encryptionKey: import.meta.env.VITE_API_ENCRYPTION_KEY as string,
};
